import { Injectable } from '@angular/core';
import { SsoRequest } from 'src/app/services/requests/sso.request';
import { User } from 'src/app/beans/login/user/user.bean';
import { ErrorManager } from 'src/app/managers/error/error.manager';

@Injectable({
  providedIn: 'root',
})
export class SsoHandler {
  constructor(
    private _request: SsoRequest,
    private _error: ErrorManager
  ) {}

  async start(tenantId: string, returnUrl: string) {
    try {
      let result: any = await this._request.start(tenantId, returnUrl);
      return result;
    } catch (error) {
      return undefined;
    }
  }

  /** undefined = nessuna sessione authproxy attiva (401) o errore di rete — stesso significato. */
  async profile() {
    try {
      let result: any = await this._request.profile();
      return result;
    } catch (error) {
      return undefined;
    }
  }

  /** undefined solo su errore di rete — il body (con eventuale redirectUrl) serve al chiamante. */
  async logout(tenantId: string, returnUrl: string) {
    try {
      return await this._request.logout(tenantId, returnUrl);
    } catch (error) {
      return undefined;
    }
  }

  /**
   * Stesso contratto di LoginHandler.login(): User se ok, MatDialogRef se serve conferma forced
   * (utente gia' loggato altrove), undefined altrimenti — ErrorManager.handleCQWebapp gestisce
   * il dispatch sui result code negativi esattamente come per il login classico.
   */
  async legacyLogin(targetApp: string, forced: boolean = false) {
    try {
      let result = await this._request.legacyLogin(targetApp, forced);

      if (!User.isKind(result))
        return this._error.handleCQWebapp(result, {
          username: (result as any)?.username,
        });

      return result as User;
    } catch (error) {
      return undefined;
    }
  }
}
